import React from 'react'
import styled from '@emotion/styled';
import { Box, Button, Container, Grid } from '@mui/material';
import Heading from '../../Components/LockerMenu/component/Heading';
import Paragraph from '../../Components/LockerMenu/component/Paragraph';
import { whitepaper } from '../../../links';
import Headervideo from '../../../assets/Headervideo.mp4'; 

const Wrapper = styled(Box)`
  padding: 60px 0px;
`;
const VideoWrapper = styled(Box)`
  width: 360px;
  height: 150px;
  border-radius: 999px;
  overflow: hidden;
  position: relative;
  margin: 0 auto 30px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #fefefe 0%, #f1f1f1 50%, #eaeaea 100%);
  box-shadow:
  0px 30px 40px -8px rgba(0, 0, 0, 0.2),
  0px 10px 15px -5px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease;

  &::before { 
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 999px;
    z-index: 3;
    top: 3px;
    left: 3px;
    bottom: 3px;
    right: 3px;
    pointer-events: none;
    border: 3px solid #ffffff; 
  }

  &::after {
    content: '';
    position: absolute;
    inset: 8px;
    border-radius: 999px;
    z-index: 2;
    background: rgba(255, 255, 255, 0.15);

    box-shadow:
      inset 0 0 10px rgba(180, 150, 255, 0.2),
      inset 0 0 6px rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 360px) {
    width: 280px;
    height: 120px;
  }

  @media (max-width: 480px) {
    width: 320px;
    height: 130px;
  }
`;


const VideoContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 999px;

  overflow: hidden;
  z-index: 1;
`;

const Video = styled('video')`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
  
`;

const Whitepaper = styled(Button)`
  padding: 18px 50px;
  background: #F4FAFF;
  border: 3px solid #d5ecff;
  color: #000;
  font-size: 16px;
  text-transform: none;
  border-radius: 13px;
`;

const CenteredParagraph = styled(Paragraph)`
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  opacity: 0.5; 
`;

const WhatAICM = () => {
  return (
    <Wrapper id="About">
      <Container maxWidth="md">
        <Grid container justifyContent={"center"}>
          <Grid xs={12} textAlign={"center"}>
            <VideoWrapper>
              <VideoContainer>
                <Video autoPlay loop muted playsInline>
                  <source src={Headervideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </Video>
              </VideoContainer>
            </VideoWrapper>
            <Heading style={{ marginBottom: '15px' }}>What is AICM?</Heading>
            <CenteredParagraph style={{ marginBottom: '15px' }}>
              AICM is an AI-powered marketplace for physical goods, digital products, and services. Built on blockchain, we provide secure, transparent, and scalable trading solutions, connecting crypto communities and revolutionizing global e-commerce.
            </CenteredParagraph>
            <a href={whitepaper} target="_blank" rel="noopener noreferrer">
              <Whitepaper>Whitepaper</Whitepaper>
            </a>
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
};

export default WhatAICM;
